import { createApp } from 'vue'
import App from './App.vue'
import './style.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

createApp(App).mount('#app')

// Register Service Worker (uses VitePWA virtual module; correct path derived from `base`)
import { registerSW } from 'virtual:pwa-register'

registerSW({ immediate: true })
